export default function TokenQueueHeader({
  filter,
  setFilter,
  selectedDate,
  setSelectedDate,
  endDate,
  setEndDate,
  branchFilter,
  setBranchFilter,
  search,
  setSearch,
  filteredVisits,
  filteredTreatmentEntries,
  filteredPackagePayments,
  exportTokensToExcel,
  resetCreateFlow,
  setShowCreate,
}) {
  return (
    <div className="space-y-4">
      {/* 🔹 Row 1 → Title + Actions */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h2 className="text-2xl font-semibold text-[#2b4c7e]">
          Today’s Tokens
        </h2>

        <div className="flex gap-3 flex-wrap">
          <button
            onClick={() => {
              resetCreateFlow();
              setShowCreate(true);
            }}
            className="px-6 py-2.5 rounded-lg bg-[#2b4c7e] text-white text-sm font-medium
            hover:bg-[#1f3a63] transition whitespace-nowrap"
          >
            + New Visit
          </button>

          <button
            onClick={() =>
              exportTokensToExcel(
                filteredVisits,
                filteredTreatmentEntries,
                filteredPackagePayments,
              )
            }
            disabled={!filteredVisits.length}
            className="px-6 py-2.5 rounded-lg bg-green-600 text-white text-sm font-medium
            hover:bg-green-700 disabled:opacity-50 transition whitespace-nowrap"
          >
            Export to Excel
          </button>
        </div>
      </div>

      {/* 🔹 Row 2 → Filters Card */}
      <div className="bg-white border rounded-xl p-5 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 items-end">
          {/* Date */}
          <div className="flex flex-col min-w-[140px]">
            <label className="text-xs text-gray-600 mb-1">Duration</label>
            <select
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                if (e.target.value !== "custom") {
                  setSelectedDate("");
                  setEndDate("");
                }
              }}
              className="border rounded-lg px-3 py-2 text-sm"
            >
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="7">Last 7 Days</option>
              <option value="30">Last 30 Days</option>
              <option value="60">Last 60 Days</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>

          {/* From */}
          <div className="flex flex-col min-w-[140px]">
            <label className="text-xs text-gray-600 mb-1">From</label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => {
                setSelectedDate(e.target.value);
                setFilter("custom"); // 🔥 important
              }}
              className="border rounded-lg px-3 py-2 text-sm"
            />
          </div>

          {/* To */}
          <div className="flex flex-col min-w-[140px]">
            <label className="text-xs text-gray-600 mb-1">To</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setFilter("custom"); // 🔥 important
              }}
              className="border rounded-lg px-3 py-2 text-sm"
            />
          </div>

          {/* Branch */}
          <div className="flex flex-col min-w-[160px]">
            <label className="text-xs text-gray-600 mb-1">Branch</label>
            <select
              value={branchFilter}
              onChange={(e) => setBranchFilter(e.target.value)}
              className="border rounded-lg px-3 py-2 text-sm"
            >
              <option value="">All Branches</option>
              <option value="Gajuwaka Branch">Gajuwaka</option>
              <option value="Kurmannapalem Branch">Kurmannapalem</option>
            </select>
          </div>

          {/* Search */}
          <div className="flex flex-col w-full sm:flex-1">
            <label className="text-xs text-gray-600 mb-1">Search</label>
            <input
              type="text"
              placeholder="Search by VPJC ID, Name, Mobile"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border rounded-lg px-3 py-2 text-sm w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
